import { render, staticRenderFns } from "./QuestionnaireStep2Cpt.vue?vue&type=template&id=20eeb3cc&scoped=true&"
import script from "./QuestionnaireStep2Cpt.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireStep2Cpt.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireStep2Cpt.vue?vue&type=style&index=0&id=20eeb3cc&lang=scss&scoped=true&"
import style1 from "./QuestionnaireStep2Cpt.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eeb3cc",
  null
  
)

export default component.exports